export function normalizeBoolean(value: unknown): boolean | null | undefined {
	if (value === null) return null;
	if (value === undefined) return undefined;
	return value === true || value === 1;
}
